var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              default: "",
              name: "about",
              label: _vm.$t("terms_and_conditions"),
              icon: "fas fa-clipboard-check"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "about" }
            },
            [
              _vm.$route.name === "terms"
                ? _c("div", { staticClass: "text-center logo-institutional" }, [
                    _c("img", {
                      staticClass: "cursor-pointer",
                      attrs: { src: _vm.login_logo },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({ name: "login" })
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row text-weight-regular q-pt-md" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("span", { domProps: { innerHTML: _vm._s(_vm.getTerm) } })
                ])
              ]),
              _c("div", { staticClass: "row reverse" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-3 text-right" },
                  [
                    _c("q-btn", {
                      attrs: {
                        flat: "",
                        color: "secondary",
                        label: _vm.$t("back"),
                        icon: "fas fa-chevron-left"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({ name: "login" })
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }